export default __webpack_public_path__ + "5a26bb13cb64f0484ddd5baa767e21a1.png";